import { AfterViewInit, Component } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PdfPreviewDialogComponent } from 'src/app/ReusableComponent/pdf-preview-dialog/pdf-preview-dialog.component';
import { OpenImageDialogComponent } from 'src/app/internalGroupChat/Dialogs/open-image-dialog/open-image-dialog.component';
import { CallFlowReturnModel, IGetCallFlowViewModel } from 'src/app/model/add-view-call-flow.model';
import { PreviewFileConfig } from 'src/app/model/preview-file.model';
import { CallFlowDetialService } from './call-flow-detail.service';
import { FileUploadInfoViewModel } from '../../../service/vendorDetailView.model';
import { NOTIFICATION_ERROR_TIME, NOTIFICATION_WARNING_TIME } from '../../../shared/properties/application.properties';

@Component({
  selector: 'app-call-flow-details',
  templateUrl: './call-flow-details.component.html',
  styleUrls: ['./call-flow-details.component.css'],
})
export class CallFlowDetailsComponent implements AfterViewInit {
  callFlowDetails: CallFlowReturnModel = {
    description: '',
    files: [],
  };
  fileType = '';
  data: IGetCallFlowViewModel;
  tripId: string;
  loader = true;
  constructor(
    private _dialog: MatDialog,
    private _callFlowDetailService: CallFlowDetialService,
    private _toast: ToastrService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
  ) {
    if (this._router.url.includes('call-flow-details')) {
      this._activatedRoute.params.subscribe((paramData) => {
        this.data = {
          ServicerequestId: paramData.serviceRequestTypeId,
          CurrentBusinessUnitId: paramData.currentBusinessUnitId,
        };
        this.tripId = paramData.tripId;
      });
    }
  }

  ngAfterViewInit(): void {
    this._callFlowDetailService.getCallFlowDetails$(this.data).subscribe(
      (res) => {
        if (res.data !== null) {
          this.callFlowDetails = res.data;
          this.loader = false;
          this.fileType = this.callFlowDetails.files.length > 0 ? this.callFlowDetails.files[0].fileType : '';
        }
      },
      () => {
        this.loader = false;
        this._toast.warning('Something went wrong! Please try again', 'Warning', {
          timeOut: NOTIFICATION_WARNING_TIME,
          positionClass: 'toast-top-center',
        });
      },
    );
  }

  downloadFile(file: FileUploadInfoViewModel) {
    if (file.fileName) {
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.href = file.filePath;
      a.download = file.fileName;
      a.click();
      document.body.removeChild(a);
    }
  }

  openImagePreview(sourcePath: string, filename: string): void {
    const imagePreviewConfig: PreviewFileConfig = {
      filePath: sourcePath,
      displayName: filename,
      isDownloadButton: false,
    };
    const dialogRef = this._dialog.open(OpenImageDialogComponent, {
      height: '100%',
      width: '100%',
      panelClass: 'image-dialog',
      data: imagePreviewConfig,
    });
  }

  openPdfPreview(sourcePath: string, filename: string) {
    const previewPdfConfig: PreviewFileConfig = {
      filePath: sourcePath,
      displayName: filename,
      isDownloadButton: true,
    };
    const dialogRef = this._dialog.open(PdfPreviewDialogComponent, {
      maxWidth: '60vw',
      width: '100%',
      minWidth: '25vw',
      height: '100vh',
      panelClass: 'pdf-dialog',
      data: previewPdfConfig,
    });
  }
  previewFiles(file: FileUploadInfoViewModel): void {
    switch (true) {
      case file.fileType.includes('png'):
      case file.fileType.includes('jpg'):
      case file.fileType.includes('jpeg'):
      case file.fileType.includes('gif'):
        this.openImagePreview(file.filePath, file.fileName);
        break;
      case file.fileType.includes('pdf'):
        this.openPdfPreview(file.filePath, file.fileName);
        break;
      default:
        this._toast.error('Unable To Preview', 'Error', {
          timeOut: NOTIFICATION_ERROR_TIME,
          positionClass: 'toast-top-center',
        });
    }
  }
}
